import {
  getFirestore,
  where,
  query,
  collection,
  updateDoc,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { TYPES } from "./service.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// ------------ add a services ----------- //
export const addService =
  ({ data, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.SERVICE);
    const uRef = collection(firestore, REF.OWNER);
    const userId = auth?.currentUser?.uid;
    const d0Ref = doc(uRef, userId);

    getDoc(d0Ref).then((snapshot) => {
      if (snapshot) {
        let dataOwner = snapshot.data();
        dataOwner = dataOwner === undefined ? false : true;

        if (dataOwner) {
          // Add a new service Data
          const id = doc(cRef).id;
          const dRef = doc(cRef, id);
          let price = data?.price;
          price = price !== "" ? Number(price) : "";
          let regularPrice = data?.regularPrice;
          regularPrice = regularPrice !== "" ? Number(regularPrice) : "";

          const serviceData = {
            ...data,
            id,
            branch,
            price,
            regularPrice,
            createAt: serverTimestamp(),
          };

          setDoc(dRef, serviceData, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          callback({
            status: 500,
            data: "You're not a owner",
          });
        }
      }
    });
  };

// ------------ add a services ----------- //
export const updateService =
  ({ detail, update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.SERVICE);
    const uRef = collection(firestore, REF.OWNER);
    const userId = auth?.currentUser?.uid;
    const d0Ref = doc(uRef, userId);

    getDoc(d0Ref).then((snapshot) => {
      if (snapshot) {
        let dataOwner = snapshot.data();
        dataOwner = dataOwner === undefined ? false : true;

        if (dataOwner) {
          // Add a new service Data
          const id = detail?.id;
          const dRef = doc(cRef, id);
          let price = update?.price;
          price = price !== "" ? Number(price) : "";
          let regularPrice = update?.regularPrice;
          regularPrice = regularPrice !== "" ? Number(regularPrice) : "";

          const serviceData = {
            ...detail,
            ...update,
            price,
            regularPrice,
            updateAt: serverTimestamp(),
          };

          updateDoc(dRef, serviceData)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          callback({
            status: 500,
            data: "You're not a owner",
          });
        }
      }
    });
  };

// ------------ add a services ----------- //
export const deleteServiceById =
  ({ id }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.SERVICE);
    const uRef = collection(firestore, REF.OWNER);
    const userId = auth?.currentUser?.uid;
    const d0Ref = doc(uRef, userId);

    getDoc(d0Ref).then((snapshot) => {
      if (snapshot) {
        let dataOwner = snapshot.data();
        dataOwner = dataOwner === undefined ? false : true;

        if (dataOwner) {
          // Add a new service Data
          const dRef = doc(cRef, id);
          deleteDoc(dRef)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          callback({
            status: 500,
            data: "You're not a owner",
          });
        }
      }
    });
  };

// ------------ select all Services ----------- //
let serviceSub = [];
export const snapAllServices =
  ({ branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.SERVICE);
    const c0 = where("branch", "==", branch);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectAllServiceSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });

    serviceSub.push(unsub);
  };

export const unSnapAll = () => (dispatch) => {
  serviceSub.forEach((subscriber) => {
    subscriber();
  });

  serviceSub.length = 0;
};

// ------------ dispatch ----------- //
const selectAllServiceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_SERVICES,
    payload: data,
  });
};
